<div class="flex-row-nowrap legend-container">
  <div class="flex-row-nowrap legend-item">
    <span class="hifen--dicomConnection"></span>
    <sh-text>
      {{ 'syngovia.label.dicomConnection' | translate }}
    </sh-text>
  </div>
  <div class="flex-row-nowrap legend-item">
    <span class="hifen--network"></span>
    <sh-text>
      {{ 'syngovia.label.network' | translate }}
    </sh-text>
  </div>
</div>
